import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';

//import { ModalModule } from 'ngx-bootstrap';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
//import { WelcomeComponent } from './welcome.component';
import { ErrorService } from './shared/services/error.service';
//import { PermissionService } from './sightlines-shared/services/permission.service';
import { UnhandledErrorHandler } from './shared/services/unhandled-errorhandler.service';
import { HotTableModule } from '@handsontable/angular';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { metaReducers, reducers } from './sightlines-portal/store/reducers';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    HotTableModule,
    FormsModule,    
    HttpClientModule,
    AppRoutingModule,
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot(),    
  ],
  declarations: [
    AppComponent,
   // WelcomeComponent
  ],
  providers: [
    ErrorService,
     { provide: ErrorHandler, useClass: UnhandledErrorHandler },
    // PermissionService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
